<template>
    <div class="body back-gray">
        <div class="wrap txt-center end">
            <h1 class="mt-20">
                지금부터 SPAC^ Writing Test를<br>시작하겠습니다.
            </h1>
            
        </div>        
        <div class="wrap">
            <div class="btn-fixed">
                <!-- <p class="start-txt">지금부터 SPAC^ Writing Test를 시작하겠습니다.</p> -->
                <p class="start-txt">START 버튼을 누르면 테스트가 진행됩니다.</p>
                <button class="btn-full"  @click="next()">START</button>
            </div>
        </div>
        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
export default {
    name: 'Setting01',
    components: {
        Footer
    },
    data: () => ({
        
    }),
    mounted() {
       
    },
    methods: {
         next(){
            location.href ='/setting02'
        }

    }
}
</script>